export default __webpack_public_path__ + "static/media/imgAboutUs4.4bb343cb.png";